import { render, staticRenderFns } from "./ButtonSeeFile.vue?vue&type=template&id=5fd638ee&"
import script from "./ButtonSeeFile.vue?vue&type=script&lang=ts&"
export * from "./ButtonSeeFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports